export default "__VITE_ASSET___SMC$492__"